var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(_vm.name))]),_c('span',{staticStyle:{"float":"right","margin-right":"250px","color":"#8492a6","font-size":"13px"}},[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }